import React, { useState } from "react";
import VisitorTab from "./VisitorTab";
import CommentsTab from "./CommentsTab";

const VisitorDashboard = () => {
  const [activeTab, setActiveTab] = useState("visitor");

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="w-full bg-gray-50 p-6">
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Dashboard</h1>
        <p className="text-gray-600">
          Monitor website visitors and manage comments
        </p>
      </div>

      {/* Main Container */}
      <div className="w-full max-w-none">
        {/* Navigation Tabs */}
        <div className="mb-6">
          <div className="flex bg-[#D1D1D1] p-1 rounded-lg max-w-md shadow-sm">
            <button
              onClick={() => handleTabChange("visitor")}
              className={`flex-1 px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${
                activeTab === "visitor"
                  ? "bg-green-500 text-white shadow-sm"
                  : "text-gray-700 hover:text-gray-900"
              }`}
            >
              Visitor
            </button>
            <button
              onClick={() => handleTabChange("comments")}
              className={`flex-1 px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${
                activeTab === "comments"
                  ? "bg-green-500 text-white shadow-sm"
                  : "text-gray-700 hover:text-gray-900"
              }`}
            >
              Comments
            </button>
          </div>
        </div>

        {/* Render appropriate tab content */}
        {activeTab === "visitor" ? (
          <VisitorTab />
        ) : (
          <CommentsTab hideActions={true} />
        )}
      </div>
    </div>
  );
};

export default VisitorDashboard;
